import { Box } from '@mui/material'

import MaterialRequirements from './MaterialRequirements'
import PriceTotals from './PriceTotals'
import Summary from './Summary'

const QuoteSummary = () => {
    return (
        <Box
            data-testid="quote-summary-panels"
            sx={{
                // The panels share the height of the tallest, usually Price totals with its editor open
                alignItems: 'stretch',
                display: 'flex',
                flexDirection: 'row',
                gap: 3,
                mt: 3,
            }}
        >
            <MaterialRequirements />
            <Summary />
            <PriceTotals />
        </Box>
    )
}

export default QuoteSummary
